import _ from 'lodash';
import { displayedOnlyStructureUtil } from '../sanat-core-utils';
import { SHARED_PARTS_PREFIX } from '../../services/StructureBuilder/structureUtil';

const isSharedBlockData = (data: any) =>
  Boolean(data) &&
  data.type === 'InternalRef' &&
  (_.isNil(data.pageId) || data.pageId === 'masterPage');

const isNestedInSharedBlock = async (editorSDK: any, componentRef: any) => {
  const rootRefHostId = displayedOnlyStructureUtil.getRootRefHostCompId(
    componentRef.id,
  );
  if (!rootRefHostId) {
    return false;
  }

  if (rootRefHostId === SHARED_PARTS_PREFIX) {
    return true;
  }

  const refComp = await editorSDK.document.components.getById('token', {
    id: rootRefHostId,
  });
  const data = await editorSDK.components.data.get('token', {
    componentRef: refComp,
  });

  return isSharedBlockData(data);
};

export const getClosedWidgetDeletedComponents = async (
  editorSDK: any,
  widgetRef: any,
) => {
  let componentRef = widgetRef;

  // It is a workaround, the right fix should be done in the viewer.
  // Do this under https://jira.wixpress.com/browse/WBL-913
  if (await isNestedInSharedBlock(editorSDK, componentRef)) {
    componentRef =
      await editorSDK.components.refComponents.getTemplateComponent('token', {
        componentRef,
      });
  }

  return editorSDK.components.refComponents.getCollapsedRefComponents('token', {
    componentRef,
  });
};
